import {
  defaultMatchers,
  instantConfigDefaultValues,
  loadInstantConfig as instantConfigLoader,
  type InstantConfigRepository,
  type GeoData,
  type WindowWithIcbm,
} from "instant-config";

export type InstantConfig = {
  config: InstantConfigRepository;
  activeKeyValues: string[];
  activeLabradorKeyValues: string[];
};

export async function loadInstantConfig(
  app: string,
  device: string,
  geo: GeoData,
) {
  const matchers = defaultMatchers({
    device,
    geo,
  });

  const {
    config: instantConfig,
    activeKeyValues,
    activeLabradorKeyValues,
  } = await instantConfigLoader(
    app,
    matchers,
    window as unknown as WindowWithIcbm,
  );

  return {
    config: {
      ...instantConfigDefaultValues,
      ...(instantConfig as InstantConfigRepository),
    },
    activeKeyValues,
    activeLabradorKeyValues,
  };
}
